import React from 'react';
  import axios2 from 'services/axios2';

  import {useParams, Link,hashHistory} from 'react-router-dom';
  import { ToastContainer, toast } from 'react-toastify';
  import NuDropdown from 'components/nubox/NuDropdown';
  import ImageUploadSingle from 'components/nubox/ImageUploadSingle';
  
  import { useStore, useDispatch } from "store/StoreProvider";

  //import listac from '../assets/img/lista2.png';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from 'reactstrap';

  /*{"id_doc_mat":"","carrera_nom":"ENFERMERIA",
    "id_mate":4,"nombre":"BIOESTADISTICA",
    "sigla":"BIA-221","id_doc":0,"docente":"","idd":0,"ope":"n",
    "id_peri":1,"periodo":"gestión 2024"}*/
  const initialForm = {
    idd:0,
    ope:'n',
    id_doc_mat:0,
    carrera_nom:'',
    id_mate : 0,
    nombre:'', //nombre materia
    sigla:'',
    id_grupo:0,
    id_doc: 0,
    docente:'',
    id_peri: 0,  
    periodo:'',   
  };
  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class ModalDocenteMateria extends React.Component {
    state = {
      modalInsertar:false,
      form: Object.assign({}, initialForm),
      
      docentes:[], /* combo grupos */
      //selected_item:{},
    };
    //------------------------------------------------------
    componentDidMount() {
      console.log('componentDidMount Modal');
      //--limpiamos el array de prueba
          
      //---------
      //this.limpiar();

      this.cargar_docentes();
    }
    //-------------------
    limpiar = () =>{
      let newForm= Object.assign({}, initialForm);
      this.setState({form: newForm });
    }
    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    };
    //----cargamos combo
    //----cargamos combo
    cargar_docentes = async() => {
      console.log('cargar_docentes')
      let param = { }
      await axios2.post('cbo_docente', param).then(res => {
          if(res.data.length>0){ 
              //this.setState({ddd: res.data, });
              console.log("res.data[0]")
              console.log(res.data[0].value)
              this.setState({
                docentes: res.data,               
              });
              //añadimos el id y ope
              //this.setState({selected_item: res.data});
              //añadimos el id y ope
              this.setState({
                form: {  ...this.state.form, 
                  id_doc: res.data[0].value,  
                  docente: res.data[0].label,
                },
              });


          }else{
            toast.error('No existen datos');
          }
      }).catch(error => {
          alert('---- Existio un error ---');
          console.log(error);
      });
      //--- colocamos el primer elemento como 
      
      
    };
    //======================================================
    showModal = () => {
      //setModalOpen(true);
      this.setState({ modalInsertar: true});
    }
    closeModal = () => {
      //setModalOpen(true);
      this.setState({ modalInsertar: false});
    }
    //========================================================
    // item {}
    //-- objeto completo desde el row
    //-- esto es asignar, creamos un nuevo row
    nuevo =(item, id_peri, periodo) =>{
      console.log('nuevo');
      //this.limpiar();
      console.log(this.state.form)
      //let id_peri = this.props.store.user.id_peri;
      //let periodo = this.props.store.user.periodo;
     
      this.setState({
        form: {
          ...this.state.form,
          idd: 0,
          ope:'n',
          carrera_nom: item.carrera_nom,
          id_mate: item.id_mate,
          nombre: item.nombre,
          sigla: item.sigla,
          id_grupo: item.id_grupo,
          id_peri: id_peri,
          periodo: periodo,
          //--el id_doc ya esta en el this.state.form.id_doc, no lo tocamos
        },
        modalInsertar: true,
      });
    }
    //---------------
    /*
    editar =(idd, id_peri, periodo)=>{
      console.log('editar');
      let param = { idd: idd, ope:'f'  }
      console.log(param)
      axios2.post( 'materia_docente_store' , param).then(res => {
        console.log(res.data);

          if(res.data !== null){               
              //---asignamos los valores
              //...res.data,
              this.setState({
                form: {
                  ...this.state.form,
                  'idd': idd,
                  'ope': 'e',
                  'id_doc':res.data.id_doc,
                  'docente':res.data.docente,
                  'id_doc_mat':res.data.id_doc_mat,
                  'id_mate':res.data.id_mate,
                  id_peri: id_peri,
                  periodo: periodo,
                },
                modalInsertar: true, // show modal
              });

              //----
          }else{
            toast.error('No existen datos');
          }

      }).catch(error => {
          alert('---- Existio un error ---');
          console.log(error);
          
      });
    }*/
    //----------------------------
    eliminar =(idd)=>{
      console.log('eliminar');
      let param = { 
        idd: idd,
        ope:'x'
      }
      //console.log(param);
      axios2.post( 'materia_docente_store', param).then(res => {
        console.log(res.data);
  
          if(res.data.exito===1){ 
              //this.limpiar();
              this.closeModal();
              toast.success('Eliminado con exito');
              this.props.okModal(); //callback
          }else{
            toast.error('Error al eliminar registro', {
              position: toast.POSITION.TOP_RIGHT
            });
          }
  
      }).catch(error => {
          alert('---- Existio un error ---');
          console.log(error);
          
      });
    }
    //----------------------------
    validar = () =>{
      if( this.state.form.id_espe===0){
        toast.error( 'Especialidad no valido', {position: toast.POSITION.TOP_RIGHT});
        return true;
      }
    }
    /************************************************ */
  
    //----------------------------
    formSave = () => {
      /*let error = this.validar();
      if(error===true){
        return;
      }*/
      
      let param = this.state.form;
      console.log("param");
      console.log(param);
  
      axios2.post('materia_docente_store', param).then(res => {
          let response = res.data;
        
          if(response.exito===1){ 
              
            toast.success( response.men, {position: toast.POSITION.TOP_RIGHT});
            //---llamamos a la funcion externa
            this.props.okModal();
            this.closeModal();
          }else{
  
            toast.error( response.men, {position: toast.POSITION.TOP_RIGHT});
          }
  
      }).catch(error => {
          alert('Bad Request');
          console.log(error);
          
      });
  
    }
    //---------------------------
    render() {
      const form= this.state;

      return (
        <div>
          <ToastContainer />
          
          {/*--- modal---- */}
          <Modal isOpen={this.state.modalInsertar} toggle={this.closeModal} >
            <ModalHeader toggle={this.closeModal} 
              className= { (this.state.form.ope==='n'? 'header-verde':'header-naranja') + ' ' + (this.state.form.ope==='n'? "color:'#45b545'":"color:'#343b43'")  } 
            >
              <h4 className="modal-title">
              { this.state.form.ope==='n'
                ? "Nuevo"
                : "Editar"
              }
              </h4>
            </ModalHeader>
  
            <ModalBody style={{background: "#F7F7F7"}}>
            {
              //JSON.stringify(this.state.form )
            }
                                 
            <form  method='POST'> 
                <div>
                  <table align='center' width="100%" className="tabla04">
                  
                      <tr>
                          <td width="20%" className="color_azul">Carrera:</td>
                          <td > 
                            <label>
                              { this.state.form.carrera_nom } 
                            </label>
                          </td>
                      </tr>
                      
                      <tr>
                          <td  width="20%" className="color_azul">Materia:</td>
                          <td > 
                            <label>
                              { this.state.form.nombre } /G{this.state.form.id_grupo}
                            </label>
                          </td>
                      </tr>
                      
                      <tr>
                          <td width="20%" className="color_azul">Docente:</td>
                          <td > 
                          <NuDropdown
                            options={this.state.docentes}
                            name='id_doc'
                            value={ this.state.form.id_doc}
                            onChange={this.handleChangeForm}
                          /> </td>
                      </tr>
                      <tr>
                          <td width="20%" className="color_azul">Periodo:</td>
                          <td > 
                          <span>
                            { this.state.form.periodo }
                          </span>
                          </td>
                      </tr>
                      
                  </table>  
                </div>
              </form>
        
              
            </ModalBody>
            <ModalFooter>
              <Button color='primary' onClick={ this.formSave}>Guardar</Button>{' '}
              <Button color='secondary' onClick={this.closeModal}>Cancel</Button>
            </ModalFooter>
          </Modal>
        </div>
      );
    }
  }
  
  //------------
  export default ModalDocenteMateria;